import { POST } from "../../index";

export const queryReminderList = (param) => POST("/v1/MaintainMaterialController/selectMaintainCarList", param);
export const insertReminder = (param) => POST("/v1/MaintainMaterialController/insertMaterial", param);

export const queryOrderList = (param) => POST("/v1/MaintainMaterialController/selectMaterialList", param);

